import React from 'react';
import { Text } from '../../Atoms';
import { CarteTpOrganism } from './../../Organisms/index';
function TemplateCarteTp (props) {
  return (
    <div className='template-scroll cartetp-container'>
      <div className='cartetp-header-container'>
        <Text
          text='Ma carte de tiers payant'
          type='h2'
          className='cartetp-title'
        />
      </div>
      <CarteTpOrganism
        check={props.check}
        checkBoxClicked={props.checkBoxClicked}
        validate={props.validate}
        validateClicked={props.validateClicked}
        download={props.download}
        showErrorModalOpen={props.showErrorModalOpen}
        onCloseErrorModal={props.onCloseErrorModal}
        handleSharing={props.handleSharing}
        civility={props.civility}
        firstName={props.firstName}
        lastName={props.lastName}
        socialSecurityNumber={props.socialSecurityNumber}
        adherentNumber={props.adherentNumber}
        startDateValidity={props.startDateValidity}
        endDateValidity={props.endDateValidity}
        addPassToWallet={props.addPassToWallet}
        addPassInProgress={props.addPassInProgress}
      />
    </div>
  );
}

export default TemplateCarteTp;
